import React from 'react';

const TermsAndConditions = () => {
    return (
        <>
            <style>{`
                body {
                    background-color: #121212;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                }

                .legal-container {
                    background-color: #1f1f1f;
                    padding: 2rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                    max-width: 900px;
                    margin: 2rem auto;
                    color: #a5a6ad;
                    font-size: 0.95rem;
                    line-height: 1.6;
                }
                
                .legal-container h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #ffffff;
                    border-bottom: 2px solid #333;
                    padding-bottom: 0.75rem;
                    margin-bottom: 2rem;
                }
                
                .legal-container h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #f0f0f0;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                }
                
                .legal-container p {
                    margin-bottom: 1.2rem;
                    color: #b0b0b0;
                }
                
                .legal-container ul {
                    list-style-type: none;
                    padding-left: 0;
                    margin-bottom: 1rem;
                }
                
                .legal-container li {
                    position: relative;
                    padding-left: 1.5rem;
                    margin-bottom: 0.75rem;
                    color: #b0b0b0;
                }
                
                .legal-container li::before {
                    content: '•';
                    color: #4a90e2;
                    position: absolute;
                    left: 0;
                    font-size: 1.2rem;
                    line-height: 1;
                }
                
                .legal-container strong {
                    color: #ffffff;
                    font-weight: 600;
                }
                
                .legal-container .highlight {
                    background-color: #2a2a31;
                    padding: 1.5rem;
                    border-radius: 0.5rem;
                    border-left: 4px solid #4a90e2;
                    margin: 2rem 0;
                }
                
                .legal-container .highlight p {
                    color: #d0d0d0;
                    margin: 0;
                }

                .company-name {
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #9e9e9e;
                    margin-bottom: 0.5rem;
                    display: block;
                }
            `}</style>
            <div className="legal-container">
                <span className="company-name">CommunityofHubs</span>
                <h2>Terms and Conditions</h2>
                <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>

                <p>
                    Welcome to CommunityofHubs! These terms and conditions outline the rules and regulations for the use of our website. By accessing this website, we assume you accept these terms and conditions. Do not continue to use CommunityofHubs if you do not agree to all of the terms and conditions stated on this page.
                </p>

                <h3>1. User Accounts</h3>
                <p>
                    When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service. You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.
                </p>

                <h3>2. Intellectual Property</h3>
                <p>
                    The Service and its original content, features, and functionality are and will remain the exclusive property of CommunityofHubs and its licensors. The Service is protected by copyright, trademark, and other laws of both India and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of CommunityofHubs.
                </p>

                <h3>3. Prohibited Activities</h3>
                <p>You agree not to use the Service for any purpose that is illegal or prohibited by these Terms. Prohibited activities include, but are not limited to:</p>
                <ul>
                    <li>Engaging in any automated use of the system, such as using scripts to send comments or messages.</li>
                    <li>Interfering with, disrupting, or creating an undue burden on the Service or the networks or services connected to the Service.</li>
                    <li>Attempting to impersonate another user or person.</li>
                    <li>Using any information obtained from the Service in order to harass, abuse, or harm another person.</li>
                </ul>

                <h3>4. Termination</h3>
                <div className="highlight">
                    <p>
                        We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
                    </p>
                </div>
                
                <h3>5. Limitation of Liability</h3>
                <p>
                    In no event shall CommunityofHubs, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
                </p>

                <h3>6. Contact Us</h3>
                <p>If you have any questions about these Terms, please contact us at: support@communityofhubs.com</p>
            </div>
        </>
    );
};

export default TermsAndConditions;